module.exports = __webpack_public_path__ + "img/right.339e9a9d.png";